import * as actions from "actions/user";
import * as R from "ramda";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case actions.FETCH_ALL_SUCCESS: {
      const users = {};
      payload.data.forEach(user => {
        users[user.id] = user;
      });
      return users;
    }

    case actions.DELETE_ONE_SUCCESS: {
      return R.dissoc(payload.id, state);
    }

    case actions.UPDATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }

    case actions.CREATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user/byId.js